import { yupResolver as baseYupResolver } from '@hookform/resolvers/yup';
import type { FieldValues, Resolver } from 'react-hook-form';
import type { AnyObjectSchema } from 'yup';

type YupSchemaOptions = {
    abortEarly?: boolean;
    stripUnknown?: boolean;
    recursive?: boolean;
    context?: unknown;
};

type YupFactoryOptions = {
    mode?: 'async' | 'sync';
    rawValues?: boolean;
};

type TypedYupResolver = <TFieldValues extends FieldValues>(
    schema: AnyObjectSchema,
    schemaOptions?: YupSchemaOptions,
    factoryOptions?: YupFactoryOptions,
) => Resolver<TFieldValues>;

const typedBaseYupResolver = baseYupResolver as unknown as TypedYupResolver;

export function yupResolver<TFieldValues extends FieldValues>(
    schema: AnyObjectSchema,
    schemaOptions?: YupSchemaOptions,
    factoryOptions?: YupFactoryOptions,
): Resolver<TFieldValues> {
    return typedBaseYupResolver(
        schema,
        schemaOptions,
        factoryOptions,
    );
}

export default yupResolver;
